import { AffiliateProgramService } from '@/services/affiliate-program.service';
import type { InviteDetailsResponse } from '@/services/affiliate-program.service';
import { useQuery } from '@tanstack/react-query';

export const useFetchInvite = (id: string) => {
  const {
    data: product,
    error,
    isPending,
  } = useQuery<InviteDetailsResponse>({
    queryKey: [`get-invite-${id}`],
    queryFn: async () => AffiliateProgramService.getInviteAffiliateProgramById(id),
  });

  return { product, error, isPending };
};
